"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlloyManager = void 0;
class AlloyManager {
    static getInstance() {
        if (this.instance) {
            return this.instance;
        }
        if (typeof globalThis !== 'undefined' &&
            typeof globalThis.window?.alloy === 'function') {
            this.instance = globalThis.window.alloy;
            return this.instance;
        }
        return null;
    }
}
exports.AlloyManager = AlloyManager;
AlloyManager.instance = null;
